import React, { useState } from "react";

interface CalculatorProps {
  onNavigateToSupport: () => void;
}

const Calculator: React.FC<CalculatorProps> = ({ onNavigateToSupport }) => {
  const [input, setInput] = useState<string>(""); 
  const [history, setHistory] = useState<string[]>([]); 
  const [error, setError] = useState<string>(""); 
  const [showModal, setShowModal] = useState<boolean>(false); 
  const [lastResult, setLastResult] = useState<string>(""); 

  const handleButtonClick = (value: string) => {
    if (value === "=") {
      try {
        if (!input || /[\+\-\*/]$/.test(input)) {
          setError("Error: Incomplete sequence");
        } else {
          if (/\/0(?![\d.])/g.test(input)) {
            setError("Error because Division by 0");
          } else {
            const result = eval(input); 
            setHistory([...history, `${input} = ${result}`]); 
            setInput(String(result)); 
            setLastResult(String(result)); 
            setError(""); 
          }
        }
      } catch (err) {
        setError("Error: Invalid calculation");
      }
    } else if (value === "C") {
      setInput(""); 
      setError(""); 
    } else if (value === "DEL") {
      setInput(input.slice(0, -1)); 
    } else if (value === "x") {
      setInput(input + "*"); 
    } else {
      setInput(input + value);
    }
  };

  const handleAnswerClick = () => {
    if (lastResult) {
      setInput(input + lastResult); 
    }
  };

  return (
    <div className="calculator-container">
      <div className="calculator-display">
        <div className="calculator-history">
          {history.length > 0 && history[history.length - 1]} {}
        </div>
        <div className="calculator-result">{input || "0"}</div>
      </div>
      <div className="calculator-buttons">
        {["C", "DEL", "?", "/"].map((btn) => (
          <button
            key={btn}
            className={btn === "?" ? "brown" : "orange"}
            onClick={() =>
              btn === "?" ? onNavigateToSupport() : handleButtonClick(btn)
            }
          >
            {btn}
          </button>
        ))}
        {["7", "8", "9", "x", "4", "5", "6", "-", "1", "2", "3", "+"].map((btn) => (
          <button
            key={btn}
            className={btn === "=" ? "equal" : "gray"}
            onClick={() => handleButtonClick(btn)}
          >
            {btn}
          </button>
        ))}
        <button
          key="0"
          className="zero-button gray"
          onClick={() => handleButtonClick("0")}
        >
          0
        </button>
        <button
          key="="
          className="equal"
          onClick={() => handleButtonClick("=")}
        >
          =
        </button>

        <button
          key="Answer"
          className="orange"
          onClick={handleAnswerClick}
        >
          Answer
        </button>
      </div>


      <button
        className="history-toggle"
        onClick={() => setShowModal(true)} 
      >
        Show History
      </button>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <button className="close" onClick={() => setShowModal(false)}>X</button>
            <h3>History:</h3>
            <ul className="history-list">
              {history.map((item, index) => (
                <li key={index}>{item}</li> 
              ))}
            </ul>
          </div>
        </div>
      )}

      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default Calculator;
